import { useEffect } from 'react';

/**
 * usePollingTimer is a custom hook that will call the callback function every pollingInterval
 * @param {Number} pollingInterval  in milliseconds
 * @param {Function} callback function to be called every pollingInterval
 */
export const usePollingTimer = (pollingInterval, callback, dependency = []) => {
    useEffect(() => {
        const timer = setInterval(() => {
            // pass the timer to the callback function
            // so that the callback function can clear the timer
            callback(timer);
        }, pollingInterval);

        return () => clearInterval(timer);
    }, [callback, dependency, pollingInterval]);
};
